import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router'

if (import.meta.env.PROD) {
  Sentry.init({
    environment: import.meta.env.MODE,
    dsn: 'https://83fa3dab7ae640e5b2d5d051e0901e3d@o183008.ingest.us.sentry.io/1274538',
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 0.05,
    tracePropagationTargets: [/^https:\/\/staging\.flowr\.is/, /^https:\/\/flowr\.is/],
  })
}
